import { render, staticRenderFns } from "./PrediccionesIAView.vue?vue&type=template&id=10c631d2&scoped=true&"
import script from "./PrediccionesIAView.vue?vue&type=script&lang=js&"
export * from "./PrediccionesIAView.vue?vue&type=script&lang=js&"
import style0 from "./PrediccionesIAView.vue?vue&type=style&index=0&id=10c631d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c631d2",
  null
  
)

export default component.exports